(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .controller('AccessTokenDialogController', AccessTokenDialogController);

    AccessTokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccessToken'];

    function AccessTokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccessToken) {
        var vm = this;

        vm.accessToken = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accessToken.id !== null) {
                AccessToken.update(vm.accessToken, onSaveSuccess, onSaveError);
            } else {
                AccessToken.save(vm.accessToken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('c3WebApp:accessTokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
